import { compareVersions } from '@upright/common/utils';
import { chain } from 'lodash';
import { Release, Maturity } from './types';

export function isStableRelease(release: Pick<Release, 'maturity'>) {
  return release.maturity === Maturity.STABLE;
}

export function isLatestPublicRelease(release: Pick<Release, 'maturity'>) {
  return release.maturity === Maturity.LATEST_PUBLIC;
}

export function isPreRelease(release: Pick<Release, 'maturity'>) {
  return release.maturity === Maturity.PRE_RELEASE;
}

// Releases are first sorted by the number (0.5.0 > 0.4.0) and then by maturity ('pre-release' > 'latest')
export function sortReleases<T extends Release>(releases: T[]): T[] {
  return chain(releases)
    .sort((a, b) => compareVersions(b.number, a.number))
    .sortBy(compareMaturity)
    .value();
}

function compareMaturity<T extends Release>(release: T) {
  if (isPreRelease(release)) {
    return 0;
  }
  if (isLatestPublicRelease(release)) {
    return 1;
  }
  if (isStableRelease(release)) {
    return 2;
  }
  return 3;
}
